import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import SideNav from './components/SideNav';
import Dashboard from './pages/Dashboard';
import Analytics from './pages/Analytics';
import Reports from './pages/Reports';
import Statistics from './pages/Statistics';
import AdvancedAnalytics from './pages/AdvancedAnalytics';
import TVDashboard from './pages/TVDashboard';
import AtrackAnalyticsDashboard from './pages/AtrackAnalyticsDashboard';
import IpmsAnalyticsDashboard from './pages/IpmsAnalyticsDashboard';

const theme = createTheme({
  palette: {
    primary: {
      main: '#667eea',
    },
    secondary: {
      main: '#764ba2',
    },
  },
  typography: {
    fontFamily: '"Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
  },
});

function AppContent() {
  const location = useLocation();
  const isTVView = location.pathname === '/tv';

  // TV view doesn't use SideNav
  if (isTVView) {
    return (
      <Routes>
        <Route path="/tv" element={<TVDashboard />} />
      </Routes>
    );
  }

  return (
    <SideNav>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/analytics/atrack" element={<AtrackAnalyticsDashboard />} />
        <Route path="/analytics/atrack/activities" element={<AtrackAnalyticsDashboard />} />
        <Route path="/analytics/atrack/users" element={<AtrackAnalyticsDashboard />} />
        <Route path="/analytics/atrack/engagement" element={<AtrackAnalyticsDashboard />} />
        <Route path="/analytics/ipms" element={<IpmsAnalyticsDashboard />} />
        <Route path="/analytics/ipms/IMPS" element={<IpmsAnalyticsDashboard />} />
        <Route path="/analytics/ipms/geographic" element={<IpmsAnalyticsDashboard />} />
        <Route path="/analytics/ipms/operations" element={<IpmsAnalyticsDashboard />} />
        <Route path="/analytics/ipms/financial" element={<IpmsAnalyticsDashboard />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/statistics" element={<Statistics />} />
        <Route path="/advanced" element={<AdvancedAnalytics />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </SideNav>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
